import React, { useState, useEffect } from 'react';
import ApiService from '../../services/api';
import {
    MonitorCog , SquareActivity , Tickets,  Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings,
    Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown,
    Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock,
    DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut,
    ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User,
    Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash,
    Grid, Cpu, Router, Network, HardDrive, Server, MonitorSpeaker,
    Radio, Wifi, Database, CircuitBoard, Power, PlugZap, UserCog, Calculator,
    Construction, Beaker, Leaf, ShieldCheck, Ruler, Square, Triangle,
    Hexagon, Maximize2, Move3D, Shapes, MapPin, Footprints, Zap as ZapIcon,
    Wind, Sparkles, Paintbrush, Gauge, QrCode, Folder, Droplets, Waves,
    Ship, LifeBuoy, Anchor, Compass, Navigation, Crosshair, AlertTriangle,
    Scissors, Rope, Wrench as WrenchIcon, HardHat, Flashlight, Radio as RadioIcon , Receipt , Briefcase
} from 'lucide-react';
import '../../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../../assets/MEP_Solutions.png';
import architecturalIcon from '../../assets/architectural_icon.png';
import civilIcon from '../../assets/civil-icon.png';
import constructionIcon from '../../assets/construction-icon.png';
import powerToolsIcon from '../../assets/power-tools_icon.png';
import sustainableIcon from '../../assets/sustainable-icon.png';
import hygienicIcon from '../../assets/hygienic-icon.png';
import '../../Styles/dashboard.css';
import * as XLSX from 'xlsx';

const UnitechOilSpillTacklePage = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('oil-spill-tackle');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('productId');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedTackleProduct, setSelectedTackleProduct] = useState(null);
    const navigate = useNavigate();

    const [tackleProducts, setTackleProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        barcodeNumber: '',
        productId: '',
        description: '',
        tackleType: 'containment_boom',
        material: 'PVC',
        dimensions: '',
        weight: '',
        capacity: '',
        operatingDepth: '',
        certification: 'IMO_MARPOL',
        manufacturer: '',
        model: '',
        deploymentMethod: 'manual',
        storageRequirements: '',
        maintenanceInterval: '6_months'
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadTackleProducts();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            setPagination(prev => ({ ...prev, page: 1 }));

            const timeoutId = setTimeout(() => {
                loadTackleProducts();
            }, searchTerm ? 300 : 100);

            return () => clearTimeout(timeoutId);
        }
    }, [user, searchTerm, sortBy, sortOrder]);

    useEffect(() => {
        if (user && pagination.page) {
            console.log('🔄 Oil Spill Tackle pagination page changed to:', pagination.page);
            loadTackleProducts();
        }
    }, [pagination.page]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);

            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadTackleProducts = async () => {
        try {
            setIsLoading(true);
            setError(null);

            const params = {
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                page: pagination.page || 1,
                limit: 20
            };

            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            console.log('🔄 Loading oil spill tackle products with params:', params);

            const response = await ApiService.getOilSpillTackle(params);

            console.log('📡 Oil Spill Tackle API Response:', response);

            if (response.success || response.products || response.data) {
                let productsArray = [];

                if (Array.isArray(response.products)) {
                    productsArray = response.products;
                } else if (Array.isArray(response.data)) {
                    productsArray = response.data;
                } else if (Array.isArray(response)) {
                    productsArray = response;
                }

                console.log('📦 Oil Spill Tackle products found:', productsArray.length);
                console.log('📄 Current page:', pagination.page);

                setTackleProducts(productsArray);

                const total = response.total || response.count || productsArray.length;
                const limit = response.limit || params.limit || 20;
                const pages = Math.max(1, Math.ceil(total / limit));

                console.log('📊 Oil Spill Tackle pagination info - Total:', total, 'Limit:', limit, 'Pages:', pages);

                setPagination(prev => ({
                    ...prev,
                    total: total,
                    pages: pages,
                    limit: limit
                }));

                setError(null);
            } else {
                console.error('❌ Oil Spill Tackle API Error:', response.message || 'Unknown error');
                setTackleProducts([]);
                setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
                setError(response.message || "Erreur lors du chargement des produits Oil Spill Tackle");
            }
        } catch (error) {
            console.error('💥 Load oil spill tackle products error:', error);
            setTackleProducts([]);
            setError(error.message || "Erreur lors du chargement des produits Oil Spill Tackle");
            setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        loadTackleProducts();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            tackleType: 'containment_boom',
            material: 'PVC',
            dimensions: '',
            weight: '',
            capacity: '',
            operatingDepth: '',
            certification: 'IMO_MARPOL',
            manufacturer: '',
            model: '',
            deploymentMethod: 'manual',
            storageRequirements: '',
            maintenanceInterval: '6_months'
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            tackleType: 'containment_boom',
            material: 'PVC',
            dimensions: '',
            weight: '',
            capacity: '',
            operatingDepth: '',
            certification: 'IMO_MARPOL',
            manufacturer: '',
            model: '',
            deploymentMethod: 'manual',
            storageRequirements: '',
            maintenanceInterval: '6_months'
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddTackleProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                tackleType: formData.tackleType,
                material: formData.material,
                dimensions: formData.dimensions,
                weight: formData.weight,
                capacity: formData.capacity,
                operatingDepth: formData.operatingDepth,
                certification: formData.certification,
                manufacturer: formData.manufacturer,
                model: formData.model,
                deploymentMethod: formData.deploymentMethod,
                storageRequirements: formData.storageRequirements,
                maintenanceInterval: formData.maintenanceInterval
            };

            const response = await ApiService.createOilSpillTackle(productData);

            if (response.success) {
                alert('Produit Oil Spill Tackle créé avec succès ! 🎉');
                closeAddModal();
                loadTackleProducts();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la création du produit');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteTackleProduct = async (productId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce produit Oil Spill Tackle ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteOilSpillTackle(productId);
                if (response.success) {
                    loadTackleProducts();
                    alert('Produit Oil Spill Tackle supprimé avec succès');
                }
            } catch (error) {
                console.error('Failed to delete oil spill tackle product:', error);
                alert('Erreur lors de la suppression du produit: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            ApiService.clearUserData();
            navigate('/login');
        }
    };

    const menuItems = [
        {
            id: 'barcoding',
            label: 'Barcoding Database',
            icon: FileText,
            path: '/barcoding'
        },
        {
            id: 'mep-solutions',
            label: 'MEP Solutions',
            icon: MepIcon,
            isImage: true,
            path: '/mep_solutions'
        },
        {
            id: 'architectural-solutions',
            label: 'Architectural Solutions',
            icon: architecturalIcon,
            isImage: true,
            path: '/architectural_solutions'
        },
        {
            id: 'civil-solutions',
            label: 'Civil Solutions',
            icon: civilIcon,
            isImage: true,
            path: '/civil_solutions'
        },
        {
            id: 'construction-chemicals',
            label: 'Construction Chemicals',
            icon: constructionIcon,
            isImage: true,
            path: '/construction_chemicals'
        },
        {
            id: 'power-tools',
            label: 'Power & Industrial Tools',
            icon: powerToolsIcon,
            isImage: true,
            path: '/power_tools'
        },
        {
            id: 'sustainable-solutions',
            label: 'Sustainable Solutions',
            icon: sustainableIcon,
            isImage: true,
            path: '/sustainable_solutions'
        },
        {
            id: 'hygienic-solutions',
            label: 'Hygienic Solutions',
            icon: hygienicIcon,
            isImage: true,
            path: '/hygienic_solutions'
        },
        {
            id: 'conversions',
            label: 'Engineering Conversions',
            icon: Calculator,
            path: '/conversion'
        },
        {
            id: 'analytics',
            label: 'Amazon Products',
            icon: BarChart3,
            path: '/amazon_products'
        },
        {
            id: 'team',
            label: 'Team Management',
            icon: Users,
            path: '/team_management'
        },
        {
            id: 'user-management',
            label: 'User Management',
            icon: UserCog,
            path: '/users_management'
        },
    ];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const tackleTypeOptions = [
        { value: 'containment_boom', label: 'Containment Boom' },
        { value: 'absorbent_boom', label: 'Absorbent Boom' },
        { value: 'skimmer', label: 'Oil Skimmer' },
        { value: 'absorbent_pad', label: 'Absorbent Pad' },
        { value: 'absorbent_roll', label: 'Absorbent Roll' },
        { value: 'dispersant', label: 'Chemical Dispersant' },
        { value: 'pump', label: 'Recovery Pump' },
        { value: 'storage_tank', label: 'Storage Tank' },
        { value: 'deployment_reel', label: 'Deployment Reel' },
        { value: 'anchor_system', label: 'Anchor System' },
        { value: 'connector', label: 'Boom Connector' },
        { value: 'repair_kit', label: 'Repair Kit' }
    ];

    const materialOptions = [
        'PVC', 'Polyurethane', 'Rubber', 'Polypropylene', 'Stainless_Steel',
        'Aluminum', 'Fiberglass', 'Neoprene', 'HDPE', 'Composite'
    ];

    const certificationOptions = [
        'IMO_MARPOL', 'USCG_Approved', 'API_Standard', 'ISO_14001',
        'OSRL_Certified', 'IPIECA_Standard', 'DNV_GL', 'ABS_Approved'
    ];

    const deploymentMethodOptions = [
        { value: 'manual', label: 'Manual Deployment' },
        { value: 'hydraulic', label: 'Hydraulic System' },
        { value: 'pneumatic', label: 'Pneumatic System' },
        { value: 'crane', label: 'Crane Deployment' },
        { value: 'vessel_mounted', label: 'Vessel Mounted' },
        { value: 'shore_based', label: 'Shore Based' }
    ];

    const maintenanceIntervalOptions = [
        { value: '1_month', label: '1 Month' },
        { value: '3_months', label: '3 Months' },
        { value: '6_months', label: '6 Months' },
        { value: '1_year', label: '1 Year' },
        { value: '2_years', label: '2 Years' },
        { value: 'as_needed', label: 'As Needed' }
    ];

    if (isAuthChecking) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    const openViewModal = (product) => {
        setSelectedTackleProduct(product);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedTackleProduct(null);
    };

    const openEditModal = (product) => {
        setSelectedTackleProduct(product);
        setFormData({
            barcodeNumber: product.barcodeNumber,
            productId: product.productId,
            description: product.description || '',
            tackleType: product.tackleType || 'containment_boom',
            material: product.material || 'PVC',
            dimensions: product.dimensions || '',
            weight: product.weight || '',
            capacity: product.capacity || '',
            operatingDepth: product.operatingDepth || '',
            certification: product.certification || 'IMO_MARPOL',
            manufacturer: product.manufacturer || '',
            model: product.model || '',
            deploymentMethod: product.deploymentMethod || 'manual',
            storageRequirements: product.storageRequirements || '',
            maintenanceInterval: product.maintenanceInterval || '6_months'
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedTackleProduct(null);
        setFormError('');
    };

    const handleEditTackleProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                tackleType: formData.tackleType,
                material: formData.material,
                dimensions: formData.dimensions,
                weight: formData.weight,
                capacity: formData.capacity,
                operatingDepth: formData.operatingDepth,
                certification: formData.certification,
                manufacturer: formData.manufacturer,
                model: formData.model,
                deploymentMethod: formData.deploymentMethod,
                storageRequirements: formData.storageRequirements,
                maintenanceInterval: formData.maintenanceInterval
            };

            const response = await ApiService.updateOilSpillTackle(selectedTackleProduct._id, productData);

            if (response.success) {
                alert('Produit Oil Spill Tackle mis à jour avec succès !');
                closeEditModal();
                loadTackleProducts();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleExportOilSpillTackle = async () => {
        try {
            setIsLoading(true);
            alert('Preparing Oil Spill Tackle export...');

            const exportParams = {
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                export: true,
                limit: 10000
            };

            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            const response = await ApiService.getOilSpillTackle(exportParams);

            if (response.success || response.products || response.data) {
                let productsToExport = [];

                if (Array.isArray(response.products)) {
                    productsToExport = response.products;
                } else if (Array.isArray(response.data)) {
                    productsToExport = response.data;
                } else if (Array.isArray(response)) {
                    productsToExport = response;
                }

                const exportData = productsToExport.map((product, index) => ({
                    'No.': index + 1,
                    'Barcode Number': product.barcodeNumber || '',
                    'Product ID': product.productId || '',
                    'Tackle Type': tackleTypeOptions.find(t => t.value === product.tackleType)?.label || product.tackleType || '',
                    'Material': product.material?.replace('_', ' ') || '',
                    'Dimensions': product.dimensions || '',
                    'Weight': product.weight || '',
                    'Capacity': product.capacity || '',
                    'Operating Depth': product.operatingDepth || '',
                    'Certification': product.certification?.replace('_', ' ') || '',
                    'Manufacturer': product.manufacturer || '',
                    'Model': product.model || '',
                    'Deployment Method': deploymentMethodOptions.find(d => d.value === product.deploymentMethod)?.label || product.deploymentMethod || '',
                    'Storage Requirements': product.storageRequirements || '',
                    'Maintenance Interval': maintenanceIntervalOptions.find(m => m.value === product.maintenanceInterval)?.label || product.maintenanceInterval || '',
                    'Description': product.description || '',
                    'Created Date': product.createdAt ? new Date(product.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                await exportOilSpillTackleToExcel(exportData, productsToExport.length);

            } else {
                throw new Error('No Oil Spill Tackle data to export');
            }
        } catch (error) {
            console.error('Oil Spill Tackle export failed:', error);
            alert('Export failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const exportOilSpillTackleToExcel = async (data, totalCount) => {
        try {
            const ws = {};
            const headers = Object.keys(data[0] || {});

            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            const wb = {
                Sheets: { 'Oil Spill Tackle': ws },
                SheetNames: ['Oil Spill Tackle']
            };

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            const today = new Date().toISOString().split('T')[0];
            const filename = `UNITECH-Oil-Spill-Tackle_${today}.xlsx`;

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            alert(`Successfully exported ${totalCount} Oil Spill Tackle products to Excel! 🎉`);

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };

    const showNotification = (message, type = 'info', duration = 3000) => {
        // Simple notification implementation
        console.log(`${type.toUpperCase()}: ${message}`);
    };

    return (
        <div className="dashboard-container">
            {/* ADD TACKLE PRODUCT MODAL */}
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '800px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#dc2626',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <LifeBuoy style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Add Oil Spill Tackle Product
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Create a new oil spill tackle equipment
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error Message */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* Form */}
                        <form onSubmit={showEditModal ? handleEditTackleProduct : handleAddTackleProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Row 1: Barcode Number and Product ID */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Numéro de Code-barres *
                                        </label>
                                        <input
                                            type="text"
                                            name="barcodeNumber"
                                            value={formData.barcodeNumber}
                                            onChange={handleInputChange}
                                            placeholder="1234567890123"
                                            required
                                            maxLength="13"
                                            pattern="[0-9]{13}"
                                            title="The barcode should be a 13-digit number."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text"
                                            name="productId"
                                            value={formData.productId}
                                            onChange={handleInputChange}
                                            placeholder="OST-BOOM-001"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 2: Tackle Type and Material */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <LifeBuoy style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Tackle Type *
                                        </label>
                                        <select
                                            name="tackleType"
                                            value={formData.tackleType}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {tackleTypeOptions.map(type => (
                                                <option key={type.value} value={type.value}>
                                                    {type.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Material *
                                        </label>
                                        <select
                                            name="material"
                                            value={formData.material}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {materialOptions.map(material => (
                                                <option key={material} value={material}>
                                                    {material.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 3: Dimensions, Weight, Capacity */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Ruler style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Dimensions
                                        </label>
                                        <input
                                            type="text"
                                            name="dimensions"
                                            value={formData.dimensions}
                                            onChange={handleInputChange}
                                            placeholder="100m x 0.6m"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Weight
                                        </label>
                                        <input
                                            type="text"
                                            name="weight"
                                            value={formData.weight}
                                            onChange={handleInputChange}
                                            placeholder="25 kg"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Droplets style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Capacity
                                        </label>
                                        <input
                                            type="text"
                                            name="capacity"
                                            value={formData.capacity}
                                            onChange={handleInputChange}
                                            placeholder="500 L"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 4: Operating Depth and Certification */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Waves style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Operating Depth
                                        </label>
                                        <input
                                            type="text"
                                            name="operatingDepth"
                                            value={formData.operatingDepth}
                                            onChange={handleInputChange}
                                            placeholder="0-50m"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Shield style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Certification *
                                        </label>
                                        <select
                                            name="certification"
                                            value={formData.certification}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {certificationOptions.map(cert => (
                                                <option key={cert} value={cert}>
                                                    {cert.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 5: Manufacturer and Model */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Building style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Manufacturer
                                        </label>
                                        <input
                                            type="text"
                                            name="manufacturer"
                                            value={formData.manufacturer}
                                            onChange={handleInputChange}
                                            placeholder="UNITECH Marine Systems"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Model
                                        </label>
                                        <input
                                            type="text"
                                            name="model"
                                            value={formData.model}
                                            onChange={handleInputChange}
                                            placeholder="UMS-BOOM-2024"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 6: Deployment Method and Maintenance Interval */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Anchor style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Deployment Method
                                        </label>
                                        <select
                                            name="deploymentMethod"
                                            value={formData.deploymentMethod}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {deploymentMethodOptions.map(method => (
                                                <option key={method.value} value={method.value}>
                                                    {method.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Clock style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Maintenance Interval
                                        </label>
                                        <select
                                            name="maintenanceInterval"
                                            value={formData.maintenanceInterval}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {maintenanceIntervalOptions.map(interval => (
                                                <option key={interval.value} value={interval.value}>
                                                    {interval.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 7: Storage Requirements */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <Box style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Storage Requirements
                                    </label>
                                    <textarea
                                        name="storageRequirements"
                                        value={formData.storageRequirements}
                                        onChange={handleInputChange}
                                        placeholder="Store in dry, temperature-controlled environment. Avoid direct sunlight."
                                        rows="3"
                                        maxLength="500"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.storageRequirements.length}/500 caractères
                                    </small>
                                </div>

                                {/* Row 8: Description */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <FileText style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Description *
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Detailed description of the oil spill tackle equipment, its capabilities, and applications."
                                        required
                                        rows="4"
                                        maxLength="1000"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginTop: '24px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={showEditModal ? closeEditModal : closeAddModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px 20px',
                                        border: '1px solid #d1d5db',
                                        background: 'white',
                                        color: '#374151',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2,
                                        padding: '12px 20px',
                                        border: 'none',
                                        background: isSubmitting ? '#9ca3af' : (showEditModal ? '#f59e0b' : '#dc2626'),
                                        color: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            {showEditModal ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                        <>
                                            <LifeBuoy style={{ width: '16px', height: '16px' }} />
                                            {showEditModal ? 'Update' : 'Create Product'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* VIEW TACKLE PRODUCT MODAL */}
            {showViewModal && selectedTackleProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#0ea5e9',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Oil Spill Tackle Details
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedTackleProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {/* Details */}
                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE-BARRES</label>
                                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                                        {selectedTackleProduct.barcodeNumber}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRODUCT ID</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.productId}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>TACKLE TYPE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {tackleTypeOptions.find(t => t.value === selectedTackleProduct.tackleType)?.label || selectedTackleProduct.tackleType}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>MATERIAL</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.material?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DIMENSIONS</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.dimensions || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>WEIGHT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.weight || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CAPACITY</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.capacity || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>OPERATING DEPTH</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.operatingDepth || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CERTIFICATION</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.certification?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>MANUFACTURER</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.manufacturer || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>MODEL</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedTackleProduct.model || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DEPLOYMENT METHOD</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {deploymentMethodOptions.find(d => d.value === selectedTackleProduct.deploymentMethod)?.label || selectedTackleProduct.deploymentMethod || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>MAINTENANCE INTERVAL</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {maintenanceIntervalOptions.find(m => m.value === selectedTackleProduct.maintenanceInterval)?.label || selectedTackleProduct.maintenanceInterval || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            {selectedTackleProduct.storageRequirements && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STORAGE REQUIREMENTS</label>
                                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                        {selectedTackleProduct.storageRequirements}
                                    </p>
                                </div>
                            )}

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                    {selectedTackleProduct.description}
                                </p>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CREATED ON</label>
                                <p style={{ margin: 0, fontSize: '14px' }}>
                                    {selectedTackleProduct.createdAt ? new Date(selectedTackleProduct.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
                                </p>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* EDIT TACKLE PRODUCT MODAL */}
            {showEditModal && selectedTackleProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Produit Oil Spill Tackle
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedTackleProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* EDIT FORM - Same as Add Form but with different submit handler */}
                        <form onSubmit={handleEditTackleProduct}>
                            {/* Same form fields as Add Modal - abbreviated for space */}
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Barcode and Product ID */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Barcode Number *
                                        </label>
                                        <input
                                            type="text" name="barcodeNumber" value={formData.barcodeNumber} onChange={handleInputChange} required
                                            maxLength="13" pattern="[0-9]{13}"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text" name="productId" value={formData.productId} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                {/* Description */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description *
                                    </label>
                                    <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="4" maxLength="1000"
                                              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>
                            {/* Form Actions */}
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                        style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                        style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div
                        className="sidebar-logo-container"
                        onClick={() => navigate('/dashboard')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '8px',
                            padding: '8px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                        title="Retour au Dashboard"
                    >
                        <div className="sidebar-logo">
                            <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                        </div>
                        <div className="sidebar-brand">
                            <h1 className="sidebar-title">UNITECH IKK</h1>
                            <p className="sidebar-subtitle">Enterprise Dashboard</p>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {filteredMenuItems.map((item) => (
                        <div
                            key={item.id}
                            className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
                            onClick={() => {
                                setActiveMenuItem(item.id);
                                navigate(item.path);
                            }}
                        >
                            {item.isImage ? (
                                <img
                                    src={item.icon}
                                    alt={item.label}
                                    className="nav-icon-image"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <item.icon
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            )}
                            <span className="nav-text">{item.label}</span>
                        </div>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <LifeBuoy style={{ width: '16px', height: '16px' }} />
                                    <span>Oil Spill Tackle</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Products</span>
                                </div>
                            </nav>
                        </div>

                        <div className="header-right">
                            <div className="search-container">
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Research..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                            </div>

                            <div className="header-actions">
                                <button
                                    className="header-button"
                                    onClick={handleRefresh}
                                    disabled={isLoading}
                                    title="Actualiser"
                                >
                                    <RefreshCw style={{
                                        width: '18px',
                                        height: '18px',
                                        transform: isLoading ? 'rotate(360deg)' : 'none',
                                        transition: 'transform 1s linear'
                                    }} />
                                </button>

                                <button
                                    className="header-button"
                                    title="Notifications"
                                >
                                    <Bell style={{ width: '18px', height: '18px' }} />
                                    {notifications.length > 0 && (
                                        <span className="notification-badge">{notifications.length}</span>
                                    )}
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/settings')}
                                    title="Paramètres système"
                                >
                                    <Settings style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/project_management')}
                                    title="Gestion de projets"
                                >
                                    <Folder style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/technical_support')}
                                    title="Technical Support"
                                >
                                    <MonitorCog style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/admin_support_it')}
                                    title="Admin Support IT"
                                >
                                    <SquareActivity style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/mytickets')}
                                    title="My Tickets"
                                >
                                    <Tickets style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/quotations')}
                                    title="Quotation System"
                                >
                                    <Receipt style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/clients')}
                                    title="Clients"
                                >
                                    <Briefcase style={{ width: '18px', height: '18px' }} />
                                </button>

                                <div className="time-display">
                                    {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Oil Spill Tackle Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Oil Spill Tackle System</h1>
                        <p className="page-subtitle">
                            Manage your UNITECH IKK oil spill tackle equipment inventory - Professional emergency response solutions for marine oil spill containment and recovery.
                        </p>

                        <div className="page-actions">
                            <button
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <LifeBuoy style={{ width: '16px', height: '16px' }} />
                                Add Tackle Equipment
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportOilSpillTackle}
                                disabled={isLoading}
                                title="Export all oil spill tackle equipment"
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Export Catalogue
                            </button>
                            <button className="action-button secondary">
                                <AlertTriangle style={{ width: '16px', height: '16px' }} />
                                Emergency Response
                            </button>
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Product ID, barcode, tackle type, manufacturer..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="productId">Product ID</option>
                                    <option value="barcodeNumber">Barcode</option>
                                    <option value="tackleType">Tackle Type</option>
                                    <option value="material">Material</option>
                                    <option value="manufacturer">Manufacturer</option>
                                    <option value="updatedAt">Last Updated</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Oil Spill Tackle Products Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                Tous les équipements Oil Spill Tackle
                            </h2>
                            <span className="table-stats">
                                {pagination.total} équipement{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                            <tr>
                                <th onClick={() => {
                                    setSortBy('barcodeNumber');
                                    setSortOrder(sortBy === 'barcodeNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Code-barres {sortBy === 'barcodeNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('productId');
                                    setSortOrder(sortBy === 'productId' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Product ID {sortBy === 'productId' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('tackleType');
                                    setSortOrder(sortBy === 'tackleType' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Tackle Type {sortBy === 'tackleType' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Material</th>
                                <th>Manufacturer</th>
                                <th onClick={() => {
                                    setSortBy('updatedAt');
                                    setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody className="table-body">
                            {tackleProducts.map((product) => {
                                return (
                                    <tr key={product._id}>
                                        <td>
                                            <div className="barcode-info">
                                                <div className="barcode-number" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                    {product.barcodeNumber}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <div className="product-name" style={{ fontWeight: '500' }}>
                                                    {product.productId}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                                <span className="tackle-type-badge" style={{
                                                    backgroundColor: '#dc2626',
                                                    color: 'white',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {tackleTypeOptions.find(t => t.value === product.tackleType)?.label || product.tackleType}
                                                </span>
                                        </td>
                                        <td>
                                                <span className="material-badge" style={{
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#374151',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {product.material?.replace('_', ' ') || 'N/A'}
                                                </span>
                                        </td>
                                        <td>
                                            {product.manufacturer || 'N/A'}
                                        </td>
                                        <td>
                                            {product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : '-'}
                                        </td>
                                        <td>
                                            <div className="actions-cell">
                                                <button
                                                    className="action-icon"
                                                    title="Voir détails"
                                                    onClick={() => openViewModal(product)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Eye style={{ width: '16px', height: '16px' }} />
                                                </button>
                                                {(user.role === 'manager' || user.role === 'admin') && (
                                                    <button
                                                        className="action-icon edit"
                                                        title="Modifier"
                                                        onClick={() => openEditModal(product)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Edit style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                                {user.role === 'admin' && (
                                                    <button
                                                        className="action-icon delete"
                                                        title="Supprimer"
                                                        onClick={() => handleDeleteTackleProduct(product._id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        {tackleProducts.length === 0 && !isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <LifeBuoy style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucun équipement Oil Spill Tackle trouvé
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Essayez de modifier vos critères de recherche ou filtres, ou ajoutez de nouveaux équipements UNITECH.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '0 auto 16px',
                                    animation: 'spin 1s linear infinite'
                                }} />
                                <p>Chargement des équipements Oil Spill Tackle...</p>
                            </div>
                        )}

                        {/* Pagination */}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '15px',
                                flexWrap: 'wrap',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                {/* Bouton Précédent */}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                                    disabled={pagination.page === 1}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === 1 ? '#f9fafb' : 'white',
                                        color: pagination.page === 1 ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <ChevronRight style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }} />
                                    Précédent
                                </button>

                                {/* Navigation par numéros de page */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    {/* Première page */}
                                    {pagination.page > 3 && (
                                        <>
                                            <button
                                                onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: 'white',
                                                    color: '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                1
                                            </button>
                                            {pagination.page > 4 && (
                                                <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                                            )}
                                        </>
                                    )}

                                    {/* Pages autour de la page actuelle */}
                                    {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                                        .filter(page =>
                                            page >= Math.max(1, pagination.page - 2) &&
                                            page <= Math.min(pagination.pages, pagination.page + 2)
                                        )
                                        .map(page => (
                                            <button
                                                key={page}
                                                onClick={() => setPagination(prev => ({ ...prev, page }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: page === pagination.page ? '#dc2626' : 'white',
                                                    color: page === pagination.page ? 'white' : '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: page === pagination.page ? '600' : '500',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (page !== pagination.page) {
                                                        e.target.style.backgroundColor = '#e5e7eb';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (page !== pagination.page) {
                                                        e.target.style.backgroundColor = 'white';
                                                    }
                                                }}
                                            >
                                                {page}
                                            </button>
                                        ))
                                    }

                                    {/* Dernière page */}
                                    {pagination.page < pagination.pages - 2 && (
                                        <>
                                            {pagination.page < pagination.pages - 3 && (
                                                <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                                            )}
                                            <button
                                                onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: 'white',
                                                    color: '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                {pagination.pages}
                                            </button>
                                        </>
                                    )}
                                </div>

                                {/* Input direct pour aller à une page */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <QrCode style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                    <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                                        Aller à:
                                    </span>
                                    <input
                                        type="number"
                                        min="1"
                                        max={pagination.pages}
                                        placeholder={pagination.page}
                                        style={{
                                            width: '60px',
                                            padding: '4px 8px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '4px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            outline: 'none'
                                        }}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                const page = parseInt(e.target.value);
                                                if (page >= 1 && page <= pagination.pages) {
                                                    setPagination(prev => ({ ...prev, page }));
                                                    e.target.value = '';
                                                    showNotification(`Navigation vers la page ${page}`, 'info', 2000);
                                                } else {
                                                    showNotification('Numéro de page invalide', 'error', 3000);
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const page = parseInt(e.target.value);
                                            if (page >= 1 && page <= pagination.pages) {
                                                setPagination(prev => ({ ...prev, page }));
                                            }
                                            e.target.value = '';
                                        }}
                                    />
                                    <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                        sur {pagination.pages}
                                    </span>
                                </div>

                                {/* Bouton Suivant */}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
                                    disabled={pagination.page === pagination.pages}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                                        color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    Suivant
                                    <ChevronRight style={{ width: '14px', height: '14px' }} />
                                </button>
                            </div>
                        )}

                        {/* Informations de pagination détaillées */}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '16px 20px',
                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: '14px',
                                color: '#6b7280'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Database style={{ width: '16px', height: '16px' }} />
                                    <span>
                                        Affichage de {((pagination.page - 1) * pagination.limit) + 1} à {Math.min(pagination.page * pagination.limit, pagination.total)}
                                        sur {pagination.total} équipements
                                    </span>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    fontSize: '12px'
                                }}>
                                    <span style={{
                                        backgroundColor: '#e5e7eb',
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                        fontWeight: '500'
                                    }}>
                                        {pagination.limit} par page
                                    </span>
                                    <span>•</span>
                                    <span>Page {pagination.page}/{pagination.pages}</span>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechOilSpillTacklePage;